import { useState, useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexto/AuthContexto";
import {
  UserGroupIcon,
  ChartIcon,
  ScaleIcon,
  LogoutIcon,
  MenuIcon,
  CloseIcon,
} from "../componentes/Iconos";

const SECCIONES = [
  { ruta: "/clientes", nombre: "Clientes", icono: UserGroupIcon },
  { ruta: "/movimientos", nombre: "Movimientos", icono: ChartIcon },
  { ruta: "/saldos", nombre: "Saldos", icono: ScaleIcon },
];

// Cabecera y menú que comparten todas las pantallas.
// El contenido de cada ruta se dibuja en <Outlet />.
const LayoutPrincipal = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [menuAbierto, setMenuAbierto] = useState(false);

  // Al cambiar de pantalla el menú se cierra solo.
  useEffect(() => {
    setMenuAbierto(false);
  }, [location.pathname]);

  // Escape cierra el menú, y mientras está abierto la página de atrás no
  // se desplaza.
  useEffect(() => {
    if (!menuAbierto) return;

    const alTeclear = (e) => {
      if (e.key === "Escape") setMenuAbierto(false);
    };
    document.addEventListener("keydown", alTeclear);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", alTeclear);
      document.body.style.overflow = "";
    };
  }, [menuAbierto]);

  return (
    <div className="app-container">
      <header className="app-header">
        <div className="header-izquierda">
          <button
            className="btn-menu"
            onClick={() => setMenuAbierto(true)}
            aria-label="Abrir menú"
            aria-expanded={menuAbierto}
          >
            <MenuIcon />
          </button>
          <h1>Rústiko</h1>
        </div>

        <div className="user-info">
          <span>Hola, {user.username}</span>
          <button onClick={logout} className="logout-btn" title="Cerrar sesión">
            <LogoutIcon />
          </button>
        </div>
      </header>

      {/* El fondo se difumina mientras el menú está abierto. */}
      <div
        className={`menu-fondo ${menuAbierto ? "visible" : ""}`}
        onClick={() => setMenuAbierto(false)}
        aria-hidden="true"
      />

      <nav className={`menu-lateral ${menuAbierto ? "abierto" : ""}`} aria-label="Secciones">
        <div className="menu-cabecera">
          <span className="menu-marca">Rústiko</span>
          <button
            className="btn-cerrar-menu"
            onClick={() => setMenuAbierto(false)}
            aria-label="Cerrar menú"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="menu-secciones">
          {SECCIONES.map(({ ruta, nombre, icono: Icono }) => (
            <NavLink
              key={ruta}
              to={ruta}
              className={({ isActive }) => `menu-enlace ${isActive ? "activo" : ""}`}
            >
              <span className="menu-enlace-icono">
                <Icono />
              </span>
              <span className="menu-enlace-texto">{nombre}</span>
            </NavLink>
          ))}
        </div>

        <button className="menu-salir" onClick={logout}>
          <LogoutIcon /> Cerrar sesión
        </button>
      </nav>

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutPrincipal;
